import React from 'react'
import TableMultiSelect from 'components/common/Form/TableMultiSelect'

export function FilterComponent({
  name,
  storeName,
  label,
  data,
  value,
  handleFilterChange,
  formatMessage,
  disableUnderline,
  allSelectedExistInList,
  setInitialData,
  handleSetInitialData,
}) {
  return (
    <TableMultiSelect
      name={name}
      storeName={storeName}
      className={name}
      label={formatMessage({ id: label })}
      data={data}
      value={value}
      onClose={handleFilterChange}
      MenuProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left',
        },
        getContentAnchorEl: null,
      }}
      disableUnderline={disableUnderline}
      allSelectedExistInList={allSelectedExistInList}
      setInitialData={setInitialData}
      handleSetInitialData={handleSetInitialData}
    />
  )
}
